module.exports = __webpack_public_path__ + "img/playngo-white.62e2eae9.svg";